// v1.20.0 — single source of truth for the client-side app version string.
// Bumped per deploy; imported anywhere the app stamps itself (e.g. the dump
// header in SgpFlowScreen so it always reflects the actual shipped build,
// not a stale hardcoded literal).
//
// IMPORTANT: This constant is auto-rewritten by the deploy script
// (`scripts/deploy.sh`) so it always matches `package.json`. Do not edit by
// hand for normal version bumps — run `npm run deploy:all:patch` (or
// `:minor` / `:major`) and let the script update both.
export const APP_VERSION = 'v1.71.17';

export const defaultPreferences = {
  kellyCriterion: 0.25,
  legsPerPage: 10,
  minBooksStraights: 5,
  minBooksSGP: 5,
  minBooksMyBooks: 3,
  unitSize: 10,
  showAllMath: true,
  showNerdMathByDefault: false,
  showAltsExpanded: true,
  // When true, results grid hides every card whose header pill EV is ≤ 0. Useful
  // for auditing whether +EV plays are flowing through; off by default so users
  // still see the full market and can decide per card.
  filterPositiveEvOnly: false,
  defaultBetMode: 'infer',
  autoSwitchMode: true,
  defaultSortMethod: 'ev',
  defaultBookSort: 'ev', // Default sort for the per-card books panel: 'ev' | 'odds' | 'mybooks'
  // Background query settings
  backgroundQueryMode: false, // When true, queries run in background by default
  doneSoundEnabled: true, // When true, plays a subtle chime when a background query completes
  // Search strictness 1–100: 1–33 Exact (only what you asked for), 34–66 Balanced
  // (default), 67–100 Broad (related markets, wider lines). Sent to nlOdds as
  // defaults.searchStrictness; mapped in functions/utils/searchStrictness.js.
  searchStrictness: 50,
  // Saved at onboarding; reserved for min-EV filtering / personalization (0 = no floor)
  evThreshold: 0,
  // Sportsbook settings
  // v1.20.6 — `myBooksPriority` removed. The single master switch is `defaultBookSort`:
  //   'ev'      = All Books mode (sort outer results by best EV across every book)
  //   'mybooks' = My Books mode  (filter to bets covered by curated books, sort by My Books EV)
  myBooks: [],
  selectedSportsbooks: ['DraftKings', 'FanDuel', 'BetMGM'],
  sportsbookLimits: {
    'DraftKings': 1000,
    'FanDuel': 1000,
    'BetMGM': 1000,
    'Caesars': 1000,
    'PointsBet': 1000
  },
  enabledSportsbookLimits: true,
  // Consensus book exclusion (v1.15.x P3) — users can choose which books influence
  // the consensus fair value. The backend always stamps a default-excluded set
  // (DFS/sweeps/stale) into devig_methods + _rawBookConsensus; users can:
  //   'include_all' — use every book that had both sides (recommended; most data)
  //   'default'     — exclude DFS/sweeps/aggregators (stricter consensus; less data)
  //   'custom'      — hand-pick which books to exclude (consensusExcludedBooks)
  consensusBookPolicy: 'include_all',
  // Case-insensitive list of book keys to exclude when consensusBookPolicy==='custom'.
  // Merged with (never overrides) the backend's default-excluded set when in 'default'.
  consensusExcludedBooks: [],
  // SGPs only, when consensusBookPolicy==='custom': books the user also counts in
  // the SGP fair value. One joins an SGP's consensus only when its quote tracks the
  // default books (within 12%); otherwise it is shown but not counted.
  consensusIncludedBooks: []
};
